import ReactGA from 'react-ga'

const GOOGLE_ANALYTICS_KEY = 'UA-149325497-1'

ReactGA.initialize(GOOGLE_ANALYTICS_KEY)
